// Only load GTM (and therefore GA4, Google Ads, and everything that fires
// through the container) on the real elker.com production site. Vercel preview
// deploys (elker-website-*.vercel.app) and localhost run the same build, so a
// build-time env check is not enough; gate on the actual runtime hostname.
// This keeps preview/localhost traffic out of analytics and stops preview
// domains showing up in GTM's "additional domains detected" warnings.
//
// Match the apex AND any elker.com subdomain (e.g. www.elker.com), since NZ is
// a path prefix (/nz/) on the same host, not a separate domain. This
// deliberately still EXCLUDES *.vercel.app previews and localhost.
// Shared with the first-party analytics beacon via composables/useIsProductionHost.
export default defineNuxtPlugin(nuxtApp => {

  const router = useRouter()
  const { gtmId } = useRuntimeConfig().public

  // No container id (development build) or not a production host: do nothing.
  if (!gtmId || !isProductionHost(window.location.hostname)) {
    return
  }

  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    event: 'gtm.js',
    'gtm.start': Date.now()
  })

  router.afterEach((to) => {
    window.dataLayer.push({
      event: 'pageview',
      page: to.fullPath
    })
  })

  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`,
        async: true,
      },
    ],
  })
})